import "./LoadingOverlayerStyle.scss";
import { IJSLComponent, IJSLVNode, refresh } from "jsl-render";

export class LoadingOverlayerComponent implements IJSLComponent {

    private show: boolean = true;

    public isEqual(node: IJSLComponent): boolean {
        return (this as any).__proto__ === (node as any).__proto__;
    }

    public showLoading(show: boolean) {
        this.show = show;
        refresh();
    }

    public render(): IJSLVNode {
        return this.show
        ? <div class="div-lds-dual-ring">
            <div class="lds-dual-ring"></div>
            </div>
        : <div></div>;
    }

}
